import script from "./indexPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=ts"

import "./indexPage.vue?vue&type=style&index=0&id=9622d2ac&lang=scss"

const __exports__ = script;

export default __exports__